import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type PostAssessmentAvailabilityPayloadType = Record<never, never>;

export type PostAssessmentAvailabilityArgsType = (
  PostRequestArgsType<PostAssessmentAvailabilityPayloadType>
);

export const apiFetchAssessmentAvailability = async ({
  domain = useTenantStore().domain,
  payload = {},
  errorConfig = {},
  callbacks = {},
}: PostAssessmentAvailabilityArgsType = {
  payload: {},
}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.assessmentAvailability({ domain }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
